import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
// import useStyles from "./styles";
import {
   
    Typography,
    Container,
    Link,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, InputAdornment, IconButton
  } from "@material-ui/core";
  import EmailIcon from '@material-ui/icons/Email';
import { makeStyles } from '@material-ui/core/styles';
import Footer from "../../pages/home/Footer"
import MailIcon from '@material-ui/icons/Mail';
import { FormControl, InputLabel, MenuItem} from "@material-ui/core";
import ParkService from "../dashboard/Locality/Service/parkService";
import ClinicService from "../dashboard/Locality/Service/clinicService";
import BranchService from "../dashboard/Locality/Service/branchService";
import ExbhitionService from "../dashboard/Locality/Service/exbhitionService";
import UserService from "../dashboard/Locality/Service/userService";
import { Card, Box, Select } from "@material-ui/core";
import PhoneIcon from '@material-ui/icons/Phone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import SRI from './images/SRI.jpg';
import CachedIcon from '@material-ui/icons/Cached';
import PhonelinkLockIcon from '@material-ui/icons/PhonelinkLock';
import PaymentIcon from '@material-ui/icons/Payment';
import CropFreeIcon from '@material-ui/icons/CropFree';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import home from './images/sriqr.svg';
import halloween from './images/Halloween_BMS_cover-Image (1).jpg';
import './styles/bootstrap.min.css';
import './styles/animate.css';
import {  useEffect } from 'react';
import './styles/tiny-slider.css';
import './styles/glightbox.min.css';
import './styles/main.css';
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
function Home(props) {
    var classes = useStyles();
    const [parkList, setParkList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [clinicList, setClinicList] = useState([]);
    const [exbhitionList, setExbhitionList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [parkId, setParkId] = useState("");
    const [clinicId, setClinicId] = useState("");
    const [branchId, setBranchId] = useState("");
    const [exbhitionId, setExbhitionId] = useState("");
    const [branchName, setBranchName] = useState("");
    const [clinicName, setClinicName] = useState("");
    const [organizationName, setOrganizationName] = useState("");
    var [isLoading, setIsLoading] = useState(false);
    var [error, setError] = useState(null);
    var [activeTabId, setActiveTabId] = useState(0);
    var [loginValue, setLoginValue] = useState("");
    var [passwordValue, setPasswordValue] = useState("");
    var [roleValue, setRoleValue] = useState("");
    const [parkName, setParkName] = useState("");  
    const handleOpen = () => {
        props.history.push('/sriqr/login')
    };
    const handleChange = () => {
        props.history.push('/sriqr/profileregistration')
    }
    const handleLogin = () => {
        props.history.push('/sriqr/branchuser')
    }
    const handleUser = () => {
        props.history.push('/sriqr/inspectorlogin')
    }
    const handleTermsConditions = () => {
        props.history.push('/sriqr/termsconditions')
    }
    const handleRefundPolicy = () => {
        props.history.push('/sriqr/refundpolicy')
    }
    const handlePrivacyPolicy = () => {
        props.history.push('/sriqr/privacypolicy')
    }
    useEffect(() => {
        getParkList();
        getClinicList();
        getBranchList();
        getExbhitionList();
        return () => {
            setParkList([]);
            setClinicList([]);
            setBranchList([]);
            setExbhitionList([]);
            setUserList([]);
        }
    }, []);
    const getParkList = () => {
        ParkService.getAllActivePark({status:true}).then((res) => {
            setParkList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getClinicList = () => {
        ClinicService.getAllClinic().then((res) => {
            setClinicList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getBranchList = () => {
        BranchService.getAllBranch().then((res) => {
            setBranchList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getExbhitionList = () => {
        ExbhitionService.getAllExbhition().then((res) => {
            setExbhitionList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
  
    const [isOpen, setIsOpen] = React.useState(false);

    const toggleNavbar = () => {

        setIsOpen(!isOpen);
    };
    const handleRedirect = () => {

        props.history.push(`ticketbooking/${parkId}/${parkName}`)
    };
    const handleRedirectDoctor = () => {

        props.history.push(`doctorbooking/${clinicId}/${clinicName}`)
    };
    const handleRedirectBranch = () => {

        props.history.push(`loanbooking/${branchId}/${branchName}`)
    };
    const handleRedirectExbhition = () => {

        props.history.push(`exbhitionbooking/${exbhitionId}/${organizationName}`)
    };
    return (
        <>
            
            <header class="header navbar-area sticky">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-12">
                            <div class="nav-inner">
                                <nav class="navbar navbar-expand-lg">
                                    <a class="navbar-brand" href="index.html">
                                        <img src={SRI} alt="some example image" style={{ height: "70px", width: "70px", backgroundColor:'white' }} />
                                    </a>
                                    {/* <h2 class="wow fadeInLeft" data-wow-delay=".4s" style={{color:'#ff6b81'}}>SriQR.com</h2> */}
                                    <button class="navbar-toggler mobile-menu-btn" onClick={toggleNavbar} type="button" data-bs-toggle="collapse"
                                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                        aria-expanded="false" aria-label="Toggle navigation">
                                        <span class="toggler-icon"></span>
                                        <span class="toggler-icon"></span>
                                        <span class="toggler-icon"></span>
                                    </button>
                                    {isOpen ? (
                                        <div className="navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                                            <ul id="nav" className="navbar-nav ms-auto">
                                                <li className="nav-item">
                                                    <a href="#home" className="page-scroll active" aria-label="Toggle navigation">Home</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleChange} className="page-scroll active" aria-label="Toggle navigation">Profile Registration</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleOpen} className="page-scroll active">Client Login</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleLogin} className="page-scroll active" aria-label="Toggle navigation">Counter Login</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleUser} className="page-scroll active">Ticket Inspector</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleTermsConditions} className="page-scroll active">Terms & Conditions</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleRefundPolicy} className="page-scroll active">Refund Policy</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handlePrivacyPolicy} className="page-scroll active">Privacy Policy</a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : (
                                        <div className="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                                            <ul id="nav" className="navbar-nav ms-auto">
                                                <li className="nav-item">
                                                    <a href="#home" className="page-scroll active" aria-label="Toggle navigation">Home</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleOpen} className="page-scroll active">Client Login</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleChange} className="page-scroll active" aria-label="Toggle navigation">Profile Registration</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleLogin} className="page-scroll active" aria-label="Toggle navigation">Counter Login</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleUser} className="page-scroll active" aria-label="Toggle navigation">Ticket Inspector</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleTermsConditions} className="page-scroll active" aria-label="Toggle navigation">Terms & Conditions</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handleRefundPolicy} className="page-scroll active" aria-label="Toggle navigation">Refund Policy</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="javascript:void(0)" onClick={handlePrivacyPolicy} className="page-scroll active" aria-label="Toggle navigation">Privacy Policy</a>
                                                </li>
                                            </ul>
                                        </div>
                                    )}

                                    {/* <div className="button add-list-button">
                                        <a href="javascript:void(0)" onClick={handleOpen} className="btn">aaAdmin Login</a>
                                    </div> */}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <section id="home" class="hero-area" style={{backgroundColor:"#fa0e311c"}}>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-5 col-md-12 col-12" >
                            <div class="hero-content" >
                                <h1 class="wow fadeInLeft" data-wow-delay=".4s" style={{color:'#ff6b81'}}>SriQR.com</h1>
                                <h3 class="wow fadeInLeft" data-wow-delay=".4s" style={{color:"#ff6b81"}}> India’s premier QR solutions provider!</h3>
              
                                <p class="wow fadeInLeft" data-wow-delay=".6s" style={{color:"#ff6b81"}}>No more Queue with QR codes!!.</p>
                                <Grid item xs={6}>
                                    <div style={{ width: 370 }}>
                                        <FormControl className={classes.formControl} fullWidth="true" style={{color:"#ff6b81"}}
                                        >
                                            <InputLabel id="demo-simple-select-label" style={{color:"#ff6b81"}}>Select Park</InputLabel>
                                            <Select 
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="parkId"
                                                label="Select Park"
                                                // value={formik.values.parkId}
                                                // onChange={(e) => setParkId(e.target.value)}
                                                onChange={e => {
                                                    setParkName(e.target.value.parkName.toLowerCase());

                                                    setParkId(e.target.value._id)
                                                }}
                                            // error={formik.touched.parkId && Boolean(formik.errors.parkId)}
                                            // helperText={formik.touched.parkId && formik.errors.parkId}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>

                                                {parkList.map((parkDet) => (
                                                    <MenuItem key={parkDet._id} value={parkDet}>{parkDet.parkName}

                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                                <div class="button wow fadeInLeft" data-wow-delay=".8s">

                                    <a href="javascript:void(0)" class="btn" style={{backgroundColor:"#ff6b81", color:'white'}} onClick={handleRedirect}><i class="lni lni-apple"></i> Book Your Ticket</a>
                                    {/* <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
                                Play</a> */}
                                </div>
                                {/* <div class="hero-content"> */}
                                    {/* <Grid item xs={6}>
                                        <div style={{ width: 370 }}>
                                            <FormControl className={classes.formControl} fullWidth="true"
                                            >
                                                <InputLabel id="demo-simple-select-label">Select Clinic</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="clinicId"
                                                    label="Select Clinic"

                                                    onChange={e => {
                                                        setClinicName(e.target.value.clinicName.toLowerCase());

                                                        setClinicId(e.target.value._id)
                                                    }}

                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>

                                                    {clinicList.map((clinicDet) => (
                                                        <MenuItem key={clinicDet._id} value={clinicDet}>{clinicDet.clinicName}

                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid> */}
                                    {/* <div class="button wow fadeInLeft" data-wow-delay=".8s">
                                        <a href="javascript:void(0)" class="btn" onClick={handleRedirectDoctor}><i class="lni lni-apple"></i> Book Your Appointment</a> */}
                                        {/* <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
Play</a> */}
                                    {/* </div> */}
                                {/* </div> */}
                            </div>
                        </div>

                        <div class="col-lg-7 col-md-12 col-12">
                            <div class="hero-image wow fadeInRight" data-wow-delay=".4s">
                                {/* <img src="assets/images/hero/phone.png" alt="#"/> */}
                                                                <img src={home} style={{ width: "95%", backgroundColor:"white" }} alt="some example image" />

                                {/* <img src={halloween} style={{ width: "95%", backgroundColor:"white" }} alt="some example image" /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* Halloween Banner Section */}
            <section style={{ padding: '20px 0', backgroundColor: '#f8f9fa' }}>
                <Container>
                    <Box style={{ textAlign: 'center' }}>
                        <img 
                            src={halloween} 
                            alt="Halloween Special" 
                            style={{ 
                                width: '100%', 
                                maxWidth: '800px', 
                                height: 'auto',
                                borderRadius: '10px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                            }} 
                        />
                    </Box>
                </Container>
            </section>
            
            <Container sx={{ py: 8 }}>
        <br></br>
        <br></br>
        <Typography variant="h4" align="center" gutterBottom>
        How It Works
        </Typography>
        <br></br>
        <Grid container spacing={4} sx={{ mt: 4 }}>
          {/* Step 1 */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
              
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#FFEACF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <HowToRegIcon fontSize="medium" color="primary" />
              </Box>
              <Typography variant="h6" gutterBottom>
              Register
              </Typography>
              <Typography variant="body2">
              Sign up and create your account in minutes
              </Typography>
            </Box>
          </Grid>

          {/* Step 2 */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#D6F7D9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                               <CropFreeIcon fontSize="medium" color="primary" />

              </Box>
              <Typography variant="h6" gutterBottom>
              Create QR Code
              </Typography>
              <Typography variant="body2">
              Generate your unique QR code for entry
              </Typography>
            </Box>
          </Grid>

          {/* Step 3 */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#CDE6FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
               <PaymentIcon fontSize="medium" color="primary" />

              </Box>
              <Typography variant="h6" gutterBottom>
              Payment Integration
              </Typography>
              <Typography variant="body2">
              Secure online transaction processing
              </Typography>
            </Box>
          </Grid>
        </Grid>
     
       
      </Container>
            <section id="features" class="features section">
                <div class="container">
                    {/* <div class="row">
                        <div class="col-12">
                            <div class="section-title" style={{padding:0}}>
                                <h3 class="wow zoomIn" data-wow-delay=".2s">Digitalization</h3>
                                <h2 class="wow fadeInUp" data-wow-delay=".4s">Your Experience Gets Better And Better Over Time.
                        </h2>
                                 <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#333' }}>
          Thanks to the UPI payments revolution in India, the widespread use of QR codes for
          transactions has become common knowledge. This serves as a strong foundation for the
          development of innovative QR code solutions. Our services cater to a wide range of needs,
          from entry tickets and applicant tokens to doctor appointments, diagnostic test registrations,
          parking facilities, and cloak rooms. We are constantly expanding into new verticals. Our
          solutions eliminate the need for cash handling in various sectors such as parks, museums, shows,
          events, cinemas, parking lots, and cloak rooms. We also offer cashless transaction options for
          finance companies to streamline the loan application process, as well as for doctor appointments
          both in-clinic and online. Our system is quick to set up and easy to use. Simply create a profile,
          add your business details, generate a QR code, poster generated, and start processing transactions
          seamlessly.
        </p>
                            </div>
                        </div>
                    </div> */}
                    <div class="row">
                        {/* <div class="col-lg-4 col-md-6 col-12">
                   
                    <div class="single-feature wow fadeInUp" data-wow-delay=".2s">
                        <i class="lni lni-cloud-upload"></i>
                        <h3>Introduction</h3>
                        <p>Sriqr.com makes it a simple, process of entry into parks, events, parking, Cloakrooms process, Diagnostic centre, gym management. Besides reports, Analytics, feedback and consultancy for upgrading services are also provided.</p>
                    </div>
                   
                </div> */}
                        {/* <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".4s">


                                <i class="lni lni-lock"><CachedIcon /></i>
                                <h3>How it Works</h3>
                                <p>
                                Each client's business is assigned a unique QR code. When the customer/visitor scans the QR code, it opens a page related to client’s business. The customer/visitor then enters their details of services required, which are processed to calculate the amount to be paid. Once the client proceeds with the payment process and the payment is received, a QR code is generated containing the details of the services availed by the client. QR code generated is scanned by authorised person of client through a mobile app, which displays the services availed, business name, date and time. No cash handling by persons, money credited directly into business account of entity
     </p>
                            </div>

                        </div>
                        <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".6s" style={{height:'446px'}}>
                                <i class="lni lni-reload"><PhonelinkLockIcon /></i>
                                <h3>Validation of QR codes reacheceived</h3>
                                <p>
                                    Android mobile app is provided to scan QR code received by customer/Visitor on successful payment.
                                    QR code received by client is scanned by authorised person of business entity to know services availed by client same is delivered. Once scanned QR code it becomes invalid. Simple process, any business can register online, Paytm team will reach and process merchant registration

                                </p>
                            </div>

                        </div>
                        <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".2s">
                                <i class="lni lni-shield"><AcUnitIcon /></i>
                                <h3>Services </h3>
                                <p>All services availed, price paid by client stored in database for generation of MIS and analytics.
                                    “Get QR” option also in application in case QR not received by user after successful payment, user enters mobile number which entered while processing, if payment done successfully, QR will be downloaded with details.
                                </p>
                            </div>

                        </div> */}
                        {/* <div class="col-lg-4 col-md-6 col-12">
                  
                    <div class="single-feature wow fadeInUp" data-wow-delay=".4s">
                        <i class="lni lni-cog"></i>
                        <h3>Process</h3>
                        <p>Simple process, any business can register online, Paytm team will reach and process merchant registration.</p>
                    </div>
                   
                </div> */}
                        {/* <div class="col-lg-6 col-md-6 col-12">

                            <div class="single-feature wow fadeInUp" data-wow-delay=".6s" style={{height:"313px"}}>
                                <i class="lni lni-layers"><PaymentIcon /></i>
                                <h3>Payments </h3>
                                <p>
                                    All payments processed are transferred by Paytm, into business entity’s bank account next day. Paytm business app updates each transaction as it receives payment. Authorised Person can view each transaction, in case client not received QR code, it can be confirmed with this app for instant process of services availed by customer.
                                </p>
                            </div>

                        </div> */}
                    </div>
                </div>
            </section>
            

        
            <section class="our-achievement section">
                <div class="container">
                    <div class="row" >
                        <div class="col-lg-10 offset-lg-1 col-md-12 col-12">
                            <div class="title">
                                <h2>Digitalization</h2>
                                
                                {/* <p>Simple process, any business can register online, Paytm team will reach and process merchant registration.</p> */}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12  col-md-11 col-10">
                            <p style={{ color: "white", textAlign:'justify', fontSize:'medium'}}>

Thanks to the UPI payments revolution in India, the widespread use of QR codes for transactions has become common knowledge. This serves as a strong foundation for the development of innovative QR code solutions.
Our services cater to a wide range of needs, from entry tickets and applicant tokens to doctor appointments, diagnostic test registrations, parking facilities, and cloak rooms. We are constantly expanding into new verticals.
Our solutions eliminate the need for cash handling in various sectors such as parks, museums, shows, events, cinemas, parking lots, and cloak rooms.
We also offer cashless transaction options for finance companies to streamline the loan application process, as well as for doctor appointments both in-clinic and online.
Our system is quick to set up and easy to use.
Simply create a profile, add your business details, generate a QR code, poster generated, and start processing transactions seamlessly.
                            </p >
                            {/* <div class="row">
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="single-achievement wow fadeInUp" data-wow-delay=".2s">
                                        <h3 class="counter"><span id="secondo1" class="countup" cup-end="100">100</span>%</h3>
                                        <p>digital</p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="single-achievement wow fadeInUp" data-wow-delay=".4s">
                                        <h3 class="counter"><span id="secondo2" class="countup" cup-end="120">120</span>K</h3>
                                        <p>Happy Users</p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="single-achievement wow fadeInUp" data-wow-delay=".6s">
                                        <h3 class="counter"><span id="secondo3" class="countup" cup-end="125">100</span>%</h3>
                                        <p>secure</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <section id="pricing" class="pricing-table section">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="section-title">
                                {/* <h3 class="wow zoomIn" data-wow-delay=".2s">pricing</h3> */}
                                <h2 class="wow fadeInUp" data-wow-delay=".4s">Services</h2>
                                {/* <p class="wow fadeInUp" data-wow-delay=".6s">There are many variations of passages of Lorem
                                    Ipsum available, but the majority have suffered alteration in some form.</p> */}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-12">

                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">

                                <div class="table-head">
                                    <h4 class="title">Park </h4>
                        {/* <p>All the basics for starting a new business</p>
                        <div class="price">
                                <h2 class="amount">$12<span class="duration">/mo</span></h2>
                            </div> */}
                        <div class="table-content">
                                        <h4 class="middle-title">Entry Tickets</h4>
                                        <p>Scan-Pay-Enter system for seamless access to parks, exhibitions, and events.</p>
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={6}>
                                    <div style={{ width: 270 }}>
                                        <FormControl className={classes.formControl} fullWidth="true"
                                        >
                                            <InputLabel id="demo-simple-select-label">Select Park</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="parkId"
                                                label="Select Park"
                                                // value={formik.values.parkId}
                                                // onChange={(e) => setParkId(e.target.value)}
                                                onChange={e => {
                                                    setParkName(e.target.value.parkName.toLowerCase());

                                                    setParkId(e.target.value._id)
                                                }}
                                            // error={formik.touched.parkId && Boolean(formik.errors.parkId)}
                                            // helperText={formik.touched.parkId && formik.errors.parkId}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>

                                                {parkList.map((parkDet) => (
                                                    <MenuItem key={parkDet._id} value={parkDet}>{parkDet.parkName}

                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s">

                                    <a href="javascript:void(0)" class="btn" onClick={handleRedirect} style={{backgroundColor:'#ff6b81'}}><i class="lni lni-apple"></i> Book Your Ticket</a>
                                    {/* <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
                                Play</a> */}
                                </div>
                                </div>
                                    {/* <div class="button">
                                        <a href="javascript:void(0)" class="btn">Click Here</a>
                                    </div> */}
                                </div>


                            </div>
                        </div> 
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">
                                <div class="table-head">
                                    <h4 class="title">Doctor </h4>
                                    {/* <p>All the basics for starting a new business</p> */}
                                    {/* <div class="price">
                                <h2 class="amount">$24<span class="duration">/mo</span></h2>
                            </div> */}
                                    <div class="table-content">
                                        <h4 class="middle-title">Doctor Appointments</h4>
                                       <p>
          Online booking for in-clinic and virtual doctor consultations.
        </p>
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={6}>
                                        <div style={{ width: 270 }}>
                                            <FormControl className={classes.formControl} fullWidth="true"
                                            >
                                                <InputLabel id="demo-simple-select-label">Select Clinic</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="clinicId"
                                                    label="Select Clinic"

                                                    onChange={e => {
                                                        setClinicName(e.target.value.clinicName.toLowerCase());

                                                        setClinicId(e.target.value._id)
                                                    }}

                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>

                                                    {clinicList.map((clinicDet) => (
                                                        <MenuItem key={clinicDet._id} value={clinicDet}>{clinicDet.clinicName}

                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s">

                                        <a href="javascript:void(0)" class="btn" onClick={handleRedirectDoctor} style={{backgroundColor:'#ff6b81'}}><i class="lni lni-apple"></i> Book Your Appointment</a>
                                        {/* <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
Play</a> */}
                                    </div>
                                </div>
                                    {/* <div class="button">
                                        <a href="javascript:void(0)" class="btn">Click Here</a>
                                    </div> */}
                                </div>


                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">
                                <div class="table-head">
                                    <h4 class="title">Bank </h4>
                                    {/* <p>All the basics for starting a new business</p> */}
                                    {/* <div class="price">
                                <h2 class="amount">$32<span class="duration">/mo</span></h2>
                            </div> */}
                                    <div class="table-content">
                                        <h4 class="middle-title">Appointment token process</h4>
                                        <p>
                                        Designed for financial institutions to process loan applicant’s appointments, generates token numbers and directs them to respective counter.
                                        </p>
                                    
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={6}>
                                        <div style={{ width: 270 }}>
                                            <FormControl className={classes.formControl} fullWidth="true"
                                            >
                                                <InputLabel id="demo-simple-select-label">Select Bank Branch</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="branchId"
                                                    label="Select Branch"
                                                  
                                                    onChange={e => {
                                                        setBranchName(e.target.value.branchName.toLowerCase());
                                                        setBranchId(e.target.value._id)
                                                    }}

                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {branchList.map((branchDet) => (
                                                        <MenuItem key={branchDet._id} value={branchDet}>{branchDet.branchName}

                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s">

                                        <a href="javascript:void(0)" class="btn" onClick={handleRedirectBranch} style={{backgroundColor:'#ff6b81'}}><i class="lni lni-apple"></i> Book Your Appointment</a>
                                        {/* <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
Play</a> */}
                                    </div>
                                </div>
                                  
                                </div>

                            </div>
                        </div>
                        {/* <div class="col-lg-4 col-md-6 col-12"> */}
                            {/* <div class="single-table wow fadeInUp" data-wow-delay=".8s">
                                <div class="table-head"> */}
                            {/* <h4 class="title">Museum</h4> */}
                            {/* <p>All the basics for starting a new business</p> */}
                            {/* <div class="price">
                                <h2 class="amount">$48<span class="duration">/mo</span></h2>
                            </div> */}
                            {/* <div class="table-content">
                                        <h4 class="middle-title">What's Included</h4>
                                        <ul class="table-list">
                                            <li><i class="lni lni-checkmark-circle"></i> Cras justo odio.</li>
                                            <li><i class="lni lni-checkmark-circle"></i> Dapibus ac facilisis in.</li>
                                            <li><i class="lni lni-checkmark-circle"></i> Morbi leo risus.</li>
                                            <li><i class="lni lni-checkmark-circle"></i> Potenti felis, in cras ligula.</li>
                                        </ul>
                                    </div> */}
                            {/* <div class="button">
                                        <a href="javascript:void(0)" class="btn">Click Here</a>
                                    </div> */}
                            {/* </div>

                            </div> */}
                        {/* </div> */}
                    </div>
                    {/* <div class="row">
                        <div class="col-lg-4 col-md-6 col-12">

                            <div class="single-table wow fadeInUp" data-wow-delay=".2s">

                                <div class="table-head">
                                    <h4 class="title">Organization </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$12<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title">Organization</h4>
                                        <p>
                                        <p>Scan-Pay-Enter system for seamless access to parks, exhibitions, and events.</p>

                                        </p>
                                    </div>
                                    <div class="hero-content">
                                    <Grid item xs={6}>
                                        <div style={{ width: 270 }}>
                                            <FormControl className={classes.formControl} fullWidth="true"
                                            >
                                                <InputLabel id="demo-simple-select-label">Select Shows</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name="exbhitionId"
                                                    label="Select Orgnization"
                                                  
                                                    onChange={e => {
                                                        setOrganizationName(e.target.value.organizationName.toLowerCase());
                                                        setExbhitionId(e.target.value._id)
                                                    }}

                                                >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {exbhitionList.map((exbhitionDet) => (
                                                        <MenuItem key={exbhitionDet._id} value={exbhitionDet}>{exbhitionDet.organizationName}

                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <br></br>
                                    <div class="button wow fadeInLeft" data-wow-delay=".8s">

                                        <a href="javascript:void(0)" class="btn" onClick={handleRedirectExbhition} style={{backgroundColor:'#ff6b81'}}><i class="lni lni-apple"></i> Book Your Appointment</a>
                                        <a href="javascript:void(0)" class="btn btn-alt"><i class="lni lni-play-store"></i> Google
Play</a>
                                    </div>
                                </div>
                                    
                                </div>


                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".4s">
                                <div class="table-head">
                                    <h4 class="title">Coaching centre  </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$24<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title">Coaching Centres & Gyms</h4>
                                        <p>            End-to-end online operations for coaching centres and gyms.
                                        </p>
                                    </div>
                                    <div class="button">

                                        <a href="javascript:void(0)" class="btn" style={{backgroundColor:'#ff6b81'}}>Click Here</a>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <div class="single-table wow fadeInUp" data-wow-delay=".6s">
                                <div class="table-head">
                                    <h4 class="title">Feedback </h4>
                                    <p>All the basics for starting a new business</p>
                                    <div class="price">
                                <h2 class="amount">$32<span class="duration">/mo</span></h2>
                            </div>
                                    <div class="table-content">
                                        <h4 class="middle-title">Feedback Application</h4>
                                        <p> Feature for collecting customer feedback.</p>
                                    </div>
                                    <div class="button">
                                        <a href="javascript:void(0)" class="btn" style={{backgroundColor:'#ff6b81'}}>Click Here</a>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div> */}
                </div>
            </section>
            <Container sx={{ py: 8 }}>
        <br></br>
        <br></br>
        <Typography variant="h4" align="center" gutterBottom>
        Why Choose Us
        </Typography>
        <br></br>
        <Grid container spacing={4} sx={{ mt: 4 }}>
          {/* Step 1 */}
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
              
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#ff6b8161",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <AccessAlarmIcon fontSize="medium"  />
              </Box>
              <Typography variant="h6" gutterBottom>
             No Queues
              </Typography>
              <Typography variant="body2">
              Skip long lines with instant access
              </Typography>
            </Box>
          </Grid>

          {/* Step 2 */}
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#ff6b8161",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  
                  mb: 2,
                }}
              >
                               <PaymentIcon fontSize="medium" color="black" />

              </Box>
              <Typography variant="h6" gutterBottom>
              cashless transactions
              </Typography>
              <Typography variant="body2">
              Secure digital payments
              </Typography>
            </Box>
          </Grid>

          {/* Step 3 */}
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#ff6b8161",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
               <LocationOnIcon fontSize="medium" color="black" />

              </Box>
              <Typography variant="h6" gutterBottom>
              Multi-Location access
              </Typography>
              <Typography variant="body2">
             One platform to all events
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                textAlign: "center",
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "#ff6b8161",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
               <CropFreeIcon fontSize="medium" color="black" />

              </Box>
              <Typography variant="h6" gutterBottom>
              Payment Integration
              </Typography>
              <Typography variant="body2">
              Secure online transaction processing
              </Typography>
            </Box>
          </Grid>
        </Grid>
     
       
      </Container>

            <section class="section call-action" style={{marginTop:"50px"}}>
                <div class="container">
                    <div class="row">
                        {/* <div class="col-lg-8 offset-lg-2 col-md-12 col-12"> */}
                        <div class="cta-content">
                            <h2 class="wow fadeInUp" data-wow-delay=".2s">Contact us
                            </h2>
                            <section id="pricing" class="pricing-table section">
                                <div class="container">

                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-12">

                                            <div class="single-table wow fadeInUp" data-wow-delay=".2s">
                                                <div class="table-head">

                                                    <  MailIcon />


                                                    <div class="table-head">
                                                        <h4 class="title">Email Us </h4>
                                                        <p style={{ color: "black" }}>amar@srshta.com Interactively grow empowered for process-centric total linkage in Digitalization.</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        {/* <div class="col-lg-6 col-md-6 col-12">
                                            <div class="single-table wow fadeInUp" data-wow-delay=".2s">
                                                <div class="table-head">
                                                    <  PhoneIcon />

                                                    <div class="table-head">
                                                        <h4 class="title">Call Us  </h4>
                                                        <p style={{ color: "black" }}>9848055562 we are always available For your any enquiries for the better development</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div> */}
                                        {/* <div class="col-lg-4 col-md-6 col-12">
                                            <div class="single-table wow fadeInUp" data-wow-delay=".2s">
                                                <div class="table-head">
                                                    <LocationOnIcon />
                                                    <div class="table-head">
                                                        <h4 class="title">Location </h4>
                                                        <p style={{ color: "black" }}>
                                                            Srshta Tech Solutions Pvt Ltd #110, Snehapuri, Nacharam, Hyderabad-17 Telagana ,INDIA</p>
                                                    </div>

                                                </div>

                                            </div>
                                        </div> */}

                                    </div>
                                </div>
                            </section>

                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </section>
            <Box
        component="footer" style={{ marginTop: "3rem" }}
        sx={{
          backgroundColor: "#0D3B66",
          color: "#fff",
          pt: 4,
          pb: 2,
          width: "100%",
        }}
      >

        <Container maxWidth="lg">
          <Grid container spacing={2}>
            {/* Logo + Tagline */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <img
                 src="/static/media/SRI.16ddde5e.jpg"
                  alt="Logo"
                  style={{ width: "85px" }}
                />
              </Box>
              <Typography variant="body2" sx={{ opacity: 0.8 }} style={{color:'white'}}>
              Making venue aceess seamless  with digital solutions.
              </Typography>
            </Grid>

            {/* Quick Links */}
            <Grid item xs={12} md={4}>
              <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem", }} style={{color:"white"}}>
                Quick Links
              </Typography>
              <br></br>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>

              <Link class="nav-item" >
                                                <a href="#javascript:void(0)" onClick={handleChange} class="page-scroll active"
                                                    aria-label="Toggle navigation" style={{color:'white'}}>Profile Registration</a>
                                            </Link>
                                            <Link class="nav-item">
                                                <a href="javascript:void(0)" onClick={handleOpen} class="page-scroll active" style={{color:'white'}}> Client Login</a>
                                            </Link>
                                           
                                            <Link class="nav-item">
                                                <a href="javascript:void(0)" onClick={handleUser} class="page-scroll active" style={{color:'white'}}> Ticket Inspector</a>
                                            </Link>
                                            <Link class="nav-item">
                                                <a href="javascript:void(0)" onClick={handleTermsConditions} class="page-scroll active" style={{color:'white'}}> Terms And Conditions</a>
                                            </Link>
                                            <Link class="nav-item">
                                                <a href="javascript:void(0)" onClick={handleRefundPolicy} class="page-scroll active" style={{color:'white'}}> Refund Policy</a>
                                            </Link>
                                            <Link class="nav-item">
                                                <a href="javascript:void(0)" onClick={handlePrivacyPolicy} class="page-scroll active" style={{color:'white'}}> Privacy Policy</a>
                                            </Link>

                {/* <Link href="#/montessori/schoolregistration" underline="hover" color="inherit">
                  Client Login
                </Link> */}
                {/* <Link href="#/montessori/login" underline="hover" color="inherit">
                 Profile Registration
                </Link>
                <Link href="#/montessori/schoolregistration" underline="hover" color="inherit">
                  Counter Login
                </Link>
                <Link href="#/montessori/login" underline="hover" color="inherit">
                Ticket Inspector
                </Link> */}
              </Box>
            </Grid>

            {/* Support */}
            <Grid item xs={12} md={4}>
              <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }} style={{color:'white'}}>
                Services
              </Typography>
              <br></br>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }} >
                <h8 href="#/montessori/privacy" underline="hover" color="inherit" style={{color:'white'}}>
                  Parks
                </h8>
                <h8 href="#/montessori/term" underline="hover" color="inherit" style={{color:'white'}}>
                  Doctor
                </h8>
                <h8 href="#/montessori/usermanual" underline="hover" color="inherit" style={{color:'white'}}>
                Bank 
                </h8>
              </Box>
            </Grid>

            {/* Contact */}
            {/* <Grid item xs={12} md={3}>
              <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }}>
                Follow Us
              </Typography>
              <br></br>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <EmailIcon sx={{ mr: 1 }} />
                <Typography variant="body2">amar@srshta.com</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PhoneIcon sx={{ mr: 1 }} />
                <Typography variant="body2">+91 8247625893</Typography>
              </Box>
            </Grid> */}
          </Grid>

          <Box
            sx={{
              borderTop: "1px solid rgba(255, 255, 255, 0.2)",
              mt: 4,
              pt: 2,
              textAlign: "center",
            }}
          >
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              © 2025 sriqr.com All rights reserved. | Developed by{" "}
              <Link
                href="https://www.srshta.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "inherit",
                  textDecoration: "underline",
                  "&:hover": {
                    color: "#ffd700",
                  },
                }}
              >
                Srshta Tech Solution Pvt Ltd
              </Link>
            </Typography>
          </Box>
        </Container>
      </Box>
        </>
    );
}

export default withRouter(Home);
